import { render, staticRenderFns } from "./PanelConfig.vue?vue&type=template&id=782d3b08&"
import script from "./PanelConfig.js?vue&type=script&lang=js&"
export * from "./PanelConfig.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports